module.exports = __webpack_public_path__ + "img/character-11.6759d1bb.svg";